//// filepath: c:\Users\Jesús del Moral\web-ayuntamiento\frontend\src\Screens\PieDeWeb.js
// src/Screens/PieDeWeb.jsx
import React from 'react';
import './PieDeWeb.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FaInstagram, FaWhatsapp, FaYoutube } from 'react-icons/fa';

const PieDeWeb = () => (
  <footer className="footer">
    <Container fluid>
      <Row className="py-5 justify-content-between">
        {/* ───── Enlaces útiles (móvil 1º; escritorio centro) ───── */}
        <Col md={4} className="mb-4 mb-md-0 order-1 order-md-2">
          <div className="text-center">
            <h5 className="footer-title">Enlaces útiles</h5>
            <ul className="footer-links list-unstyled">
              <li>
                <a
                  href="/uploads/cookies/politica_de_privacidad3.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a
                  href="/uploads/cookies/aviso_legal3.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Aviso Legal
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/place/Pl.+España,+1,+45517+Escalonilla,+Toledo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Mapa del Sitio
                </a>
              </li>
            </ul>
          </div>
        </Col>

        {/* ───── Contacto + Redes (móvil 2º; escritorio derecha) ───── */}
        <Col md={4} className="mb-4 mb-md-0 order-2 order-md-3">
          <div className="text-center">
            <h5 className="footer-title">Contacto</h5>
            <address className="footer-text">
              Dirección:&nbsp;
              <a
                href="https://goo.gl/maps/SxYjRAh6t7CCfyEu8"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Pl. España&nbsp;1, 45517 Escalonilla, Toledo
              </a>
              <br />
              Teléfono:&nbsp;
              <a href="tel:925758111" className="footer-link">925&nbsp;75&nbsp;81&nbsp;11</a>
              <br />
              Email:&nbsp;
              <a
                href="mailto:ayuntamiento@escalonilla.com"
                className="footer-link"
              >
                ayuntamiento@escalonilla.com
              </a>
            </address>
            <div className="iconos-redes-sociales d-flex justify-content-center">
              <a
                href="https://www.instagram.com/ayuntamientodeescalonilla?igsh=MTkzb2h1bG9wYmU0ZA=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="icono-red-social"
              >
                <FaInstagram />
              </a>
              <a
                href="https://whatsapp.com/channel/0029VasoHEs7IUYOd627A746"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="icono-red-social"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://plenos-escalonilla.web.app/f"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Plenos Escalonilla"
                className="icono-red-social"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </Col>

        {/* ───── Protección de datos (móvil 3º; escritorio izquierda) ───── */}
        <Col md={4} className="order-3 order-md-1">
          <div className="text-center">
            <h5 className="footer-title">Protección de datos</h5>
            <ul className="footer-links list-unstyled">
              <li>
                <a
                  href="/uploads/cookies/nombramiento_DPO_laboral.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Nombramiento del Delegado de Protección de Datos
                </a>
              </li>
              <li>
                <a
                  href="/uploads/cookies/registro_actividades_de_tratamiento.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Registro de actividades de tratamiento
                </a>
              </li>
              <li>
                <a
                  href="/uploads/cookies/ejercicio_dchos_interesados.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Ejercicio de derechos por afectados
                </a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>

      {/* ───── copyright ───── */}
      <Row className="text-center mt-4">
        <Col>
          <hr className="footer-divider" />
          <p className="footer-copy">
            © {new Date().getFullYear()} Ayuntamiento de Escalonilla. Desarrollado por{' '}
            <a 
              href="https://www.linkedin.com/in/jesus-del-moral-gomez" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
            >
              Jesús del Moral Gómez
            </a>.
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default PieDeWeb;